import React from "react";
import { Link } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@hugeicons/core-free-icons";
import { useCustomContext } from "../../_helper/customizer";

export const BackButton = ({ to }) => {
  const { layout } = useCustomContext();
  const rtl = layout === "rtl";

  return (
    <Link
      to={to}
      className="btn btn-secondary btn-outline btn-icon btn-xs"
    >
      <HugeiconsIcon size={16} icon={rtl ? ArrowRightIcon : ArrowLeftIcon} />
    </Link>
  );
};
